<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="modal-card is-full-screen">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head pb-0">
      <div class="modal-card-title">
        <strong class="is-size-5">
          {{ General.WARNING.toUpperCase() }}
        </strong>
        <b-icon type="is-green-lawn" icon="alert-circle" size="is-large" />
      </div>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <h1
      class="
        has-text-color-7
        is-size-5
        has-text-weight-bold
        has-text-centered
        mt-10
      "
    >
      {{ App.ProcessViewer.MODAL_1.CHANGED_VIEW }}
    </h1>

    <div
      class="modal-content-container has-text-centered has-text-color-7 info-container"
    >
      <span v-html="App.ProcessViewer.MODAL_2.INFO_TEXT_1" />
      <span v-html="App.ProcessViewer.MODAL_2.INFO_TEXT_2" />
      <div class="image-container">
        <span class="is-size-5 has-text-weight-bold">
          {{ App.ProcessViewer.MODAL_2.NEW_PROCESS_VIEWER }}
        </span>
        <b-image
          :src="require('@/assets/images/processViewer.png')"
          alt="Imagem da visualização de documentos do processo"
          :responsive="false"
        />
      </div>
      <span>
        {{ App.ProcessViewer.MODAL_2.INFO_TEXT_3 }}
      </span>
    </div>

    <div class="is-flex is-justify-content-center mb-20">
      <b-button
        tag="a"
        href="https://suite.seplag.ce.gov.br/?p=202"
        target="_blank"
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
      >
        {{ buttonLabel }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalNotification",

  props: {
    buttonLabel: {
      type: String,
      default: General.OK
    },

    noticeTitle: {
      type: String,
      default: ""
    },

    bodyHtml: {
      type: String,
      required: true
    },

    callback: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },

  methods: {
    confirmAction() {
      this.callback();
      this.close();
    },

    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-height: 430px;
  width: 800px;
  background-color: $color-1;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-card-head {
  display: flex;
  align-items: flex-start;
}

.modal-card-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 85%;
  margin: 20px auto;
  gap: 10px;
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  gap: 10px;
  background-color: $color-2;
}

.custom-button {
  max-width: 150px;
}
</style>
